import { render } from "./FeaturedGalleries.vue?vue&type=template&id=b2c36d14&scoped=true"
import script from "./FeaturedGalleries.vue?vue&type=script&lang=js"
export * from "./FeaturedGalleries.vue?vue&type=script&lang=js"

import "./FeaturedGalleries.vue?vue&type=style&index=0&id=b2c36d14&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c36d14"]])

export default __exports__